<div class="right-side p-5">
  <div class="section">
    <form [formGroup]="grievanceForm" class="w-100">

      <div class="card mb-3">
        <div class="card-header"> <h2>Grievance Raiser Form</h2></div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Choose Grievance</mat-label>
                <mat-select formControlName="typeOfGrievance">
                  <mat-option *ngFor="let grievance of GrievanceList" [value]="grievance.id">{{ grievance.grievanceName }}</mat-option>
                </mat-select>
                <mat-error>
                  <div *ngIf="grievanceForm.get('typeOfGrievance')?.errors?.['required'] && grievanceForm.get('typeOfGrievance')?.touched" class="alert alert-danger">
                    Please select Grievance Type.
                  </div>
                </mat-error>
              </mat-form-field>

            </div>
            <div class="col-md-3">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Subject</mat-label>
                <input matInput formControlName="subject" placeholder="Enter subject" autocomplete="off" type="text">
                <mat-error class="text-danger">                  
                  <div *ngIf="grievanceForm.get('subject')?.errors?.['pattern'] && grievanceForm.get('subject')?.touched">
                    Please enter valid Subject.
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Description</mat-label>
                <textarea matInput formControlName="description" placeholder="Enter Description" autocomplete="off" type="text"></textarea>
                <mat-error class="text-danger">
                  <div *ngIf="grievanceForm.get('description')?.errors?.['required'] && grievanceForm.get('description')?.touched" class="alert alert-danger">
                    Description is required.
                  </div>
                  <div *ngIf="grievanceForm.get('description')?.errors?.['pattern'] && grievanceForm.get('description')?.touched">
                    Please enter valid Description.
                  </div>
                </mat-error>
              </mat-form-field>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <mat-card-content>
                <input class="form-control" type="file" (change)="onGrievanceFileSelected($event)" formControlName="documents"
                       accept=".jpg, .jpeg, .png, .pdf, .zip" />
              </mat-card-content>
              <mat-error class="text-danger">
                <div *ngIf="grievanceDocumentfileErrors?.typeError">
                  Invalid file type. Only images (jpeg, jpg, png) or pdfs are allowed.
                </div>
                <div *ngIf="grievanceDocumentfileErrors?.sizeError">
                  File size exceeds the 2MB limit.
                </div>
              </mat-error>
            </div>
          </div>
        </div>
      </div>

    </form>
    <button type="submit" (click)="onSubmit(grievanceForm)" class="btn btn-success me-2">Submit</button>
    <button (click)="Reset()" class="btn btn-danger mx-2">Cancel</button>
    <button (click)="onPressBack()" class="btn btn-info">Back</button>

  </div>


  
</div>


